<template>
    <page>
        <module enable-flex>
            <m-search ref="search" @search="searchHandle">
                <c-form>
                    <c-form-item type="input" label="活动名称" name="activity_name"></c-form-item>
                    <c-form-item type="checkbox" name="start_state" :options="activityState"></c-form-item>
                </c-form>
            </m-search>

            <m-operate>
                <c-button power="b_activity_new_edit" color="sys" @click="navigateTo('/activity_new_add')">新建活动</c-button>
                <c-button power="b_activity_new_edit" color="black" @click="otherConfig()">“新用户”标准设置</c-button>
            </m-operate>

            <c-table ref="table">

                <c-table-column
                        label="活动状态"
                        name="start_state"
                        width="80"
                >
                    <template v-slot="{data}">
                        <span v-if="data.start_state == 0" style="color:#999">{{activityStateText[data.start_state]}}</span>
                        <span v-if="data.start_state == 1" style="color:dodgerblue">{{activityStateText[data.start_state]}}</span>
                        <span v-if="data.start_state == 2" style="color:red">{{activityStateText[data.start_state]}}</span>
                    </template>
                </c-table-column>

                <c-table-column
                        label="启/禁用状态"
                        name="state"
                        width="90"
                >
                    <template v-slot="row">
                        <c-switch v-if="auth('b_activity_new_edit') && row.data.start_state == 0||row.data.start_state == 1" :value="row.data.state == 2" text="启用,禁用"
                                  @change="changeActivityState(row, arguments[0], arguments[1])"></c-switch>
                        <strong v-if="row.data.start_state == 2 && row.data.state == 1" style="color: darkgray">禁用</strong>
                        <strong v-if="row.data.start_state == 2 && row.data.state == 2" style="color: green">启用</strong>
                    </template>
                </c-table-column>

                <c-table-column
                        label="活动名称"
                        name="activity_name"
                        width="200"
                ></c-table-column>

                <c-table-column
                        label="下单数"
                        name="order_count"
                        width="80"
                ></c-table-column>

                <c-table-column
                        label="支付订单数"
                        name="order_pay_count"
                        width="100"
                ></c-table-column>

                <c-table-column
                        label="活动时间"
                        width="280"
                >
                    <template v-slot="{data}">{{data.begin_date}} - {{data.end_date}}</template>
                </c-table-column>

                <c-table-column
                        label="创建时间"
                        name="create_date"
                        width="140"
                >
                </c-table-column>

                <c-table-column
                        type="button"
                        fixed="right"
                        label="操作"
                        width="160"
                >
                    <template v-slot="row">
                        <c-table-button power="m_activity_new" @click="navigateTo(`/activity_new_detail/${row.data.id}`)">查看</c-table-button>
                        <c-table-button power="b_activity_new_edit" v-if="row.data.state == 1 || row.data.start_state == 2"
                                        @click="navigateTo(`/activity_new_edit/${row.data.id}`)">编辑</c-table-button>
                        <c-table-button power="b_activity_new_edit" v-if="row.data.state == 1 || row.data.start_state == 2" @click="deleteActivity(row)">删除</c-table-button>
                    </template>
                </c-table-column>
            </c-table>
        </module>

        <c-dialog ref="editDialog" title="“新用户”标准配置" width="600" @resolve="submitForm">
            <c-form ref="editForm">
                <c-form-item type="number" decimal="0" label="注册天数" :limit="[1,9999]" name="MEMBER_REGISTER_DAYS" required input-unit="天"
                             word="用户注册时间超过X天，则不算新用户"></c-form-item>
                <c-form-item type="number" decimal="0" label="下单数量" :limit="[0,9999]" name="MEMBER_ORDER_COUNT" required input-unit="单"
                             word="用户下单总数量超过X单，则不算新用户(不填写默认为0，即只要存在已支付订单，即非新用户)"></c-form-item>
            </c-form>
        </c-dialog>

    </page>
</template>

<script>
import {mapGetters, mapState} from "vuex";

export default {
        name: 'm_activity_new',

        data() {
            return {
                activityState: [
                    {name: '未开始',value: 0},
                    {name: '进行中',value: 1},
                    {name: '已结束',value: 2}
                ],
                stateOptions: [
                    {name: '禁用',value: 1},
                    {name: '启用',value: 2}
                ]
            }
        },

        computed: {
            ...mapState(['systemConfig', 'userInfo']),
            ...mapGetters({
                auth: 'power'
            }),
            activityStateText() {
                var state = {};
                this.activityState.forEach(item => {
                    state[item.value] = item.name;
                });

                return state;
            }
        },

        mounted() {
            this.$refs.search.search();
            this.$bus.$on('activityNewList.update', () => {
                this.$refs.table.update();
            });
        },

        methods: {
            searchHandle(data) {
                this.$refs.table.load({
                    url: '/activity/new/list',
                    data
                });
            },

            disableActivity(item,state) {
                this.$confirm({
                    text: state == 2 ? '确定要开始此新人活动吗？' : '确定要暂停此新人活动吗',
                    resolve: () => {
                        this.request({
                            url: '/activity/new/updateActivityState',
                            data: {
                                id: item.data.id,
                                state: state
                            },
                            loading: true,
                            success: () => {
                                this.$message({
                                    text: state == 2 ? '开始成功' :'暂停成功'
                                });
                                this.$refs.table.update();
                            },
                            fail: (code, data, msg) => {
                                this.$confirm({
                                    text: msg,  // 提示内容,
                                    buttonName: '知道了',  // 确定按钮文字
                                    cancelButton: false  // 是否显示取消按钮
                                });
                                return false;
                            }
                        });
                    }
                });
            },

            deleteActivity(item) {
                this.$confirm({
                    text: '确定要删除此活动【'+item.data.activity_name+'】吗？',
                    resolve: () => {
                        this.request({
                            url: '/activitySale/remove',
                            data: {
                                id: item.data.id
                            },
                            loading: true,
                            success: () => {
                                this.$message({
                                    text: '删除成功'
                                });
                                this.$refs.table.update();
                            }
                        });
                    }
                });
            },

            copyActivity(item) {
                this.request({
                    url: '/activity/new/copy',
                    data: {
                        id: item.data.id
                    },
                    loading: true,
                    success: () => {
                        this.$message({
                            text: '复制成功'
                        });
                        this.$refs.table.update();
                    }
                });
            },

            otherConfig(){
                this.request({
                    url: '/activity/new/config',
                    loading: true,
                    success: (data) => {
                        this.$refs.editForm.clear();
                        this.$refs.editForm.set(data);
                        this.$refs.editDialog.open();
                    }
                });
            },
            submitForm(stop) {
                stop();
                let submitUrl = '/activity/new/config/update';
                this.$refs.editForm.submit({
                    url: submitUrl,
                    rule: {
                        MEMBER_REGISTER_DAYS: [{
                            type: 'empty',
                            word: '请输入用户注册天数'
                        }],
                        MEMBER_ORDER_COUNT: [{
                            type: 'empty',
                            word: '请输入用户下单数量'
                        }]
                    },
                    dataFormatter: data => {
                        let platform_config_list = [];
                        let obj1={},obj2={};
                        obj1.config_item_code="MEMBER_REGISTER_DAYS";
                        obj1.config_item_value= data.MEMBER_REGISTER_DAYS;
                        obj2.config_item_code="MEMBER_ORDER_COUNT";
                        obj2.config_item_value= data.MEMBER_ORDER_COUNT;
                        platform_config_list.push(obj1,obj2);
                        data.platform_config_list = platform_config_list;
                        return data;
                    },
                    success:(data,res) => {
                        this.$message({
                            text: '操作成功',
                            icon: 'success'
                        });
                        this.$refs.editDialog.close();
                    },
                });
            },
            /**
             * 活动启禁用
             * @param state true = 启用  false=禁用
             */
            changeActivityState(item,state, stop) {
                stop();
                this.$confirm({
                    text: '确定要'+(state?"启用":"禁用")+'砍价活动【'+item.data.activity_name+'】吗？',
                    resolve: () => {
                        this.request({
                            url: '/activitySale/updateActivityState',
                            data: {
                                id: item.data.id,
                                state:state?2:1
                            },
                            loading: true,
                            success: () => {
                                this.$message({
                                    text: state ? '启用成功' : '禁用成功'
                                });
                                this.$refs.table.update();
                            },
                            fail: (code, data, msg) => {
                                this.$confirm({
                                    text: msg,  // 提示内容,
                                    buttonName: '知道了',  // 确定按钮文字
                                    cancelButton: false  // 是否显示取消按钮
                                });
                                return false;
                            }
                        });
                    }
                });
            },
        }
    }
</script>